import React from "react";
import { TYPE_PC, TYPE_SP } from "./defines";
import masterData from "../lib/masterData";
import { Link } from "../lib/Link";
import { modal } from "./modal";
import areas from "./areas";
import { getUrl } from "../lib/masterUtil";

export const area_selector = (type, value) => {
  const getPrefUrl = prefSlug => {
    if (value) {
      const prefId = masterData.pref.bySlug[prefSlug].prefId;
      return getUrl({ condition: Object.assign({ pref: prefId }, value.condition) })
    } else {
      const queryString = location.search ? 'list/' + location.search : '';
      return `/${prefSlug}/${queryString}`
    }
  }

  if (type == TYPE_SP) {
    return (
      <div className="area_selector">
        <div className="area" id="area_sp">

          <Link className="spmenu" to={getPrefUrl('tokyo')}>
            <span>東京都</span>
          </Link>
          <Link className="spmenu" to={getPrefUrl('chiba')}>
            <span>千葉県</span>
          </Link>
        </div>
        <div className="area" id="area_sp">
          <Link className="spmenu" to={getPrefUrl('saitama')}>
            <span>埼玉県</span>
          </Link>
          <Link className="spmenu" to={getPrefUrl('kanagawa')}>
            <span>神奈川県</span>
          </Link>
        </div>
        <div className="area" id="area_sp">
          <Link className="spmenu" to={getPrefUrl('osaka')}>
            <span>大阪府</span>
          </Link>
        </div>
        <div
          className="area spmenu link"
          id="area_sp"
          onClick={() => modal.openModal("menu_big_area", { value })}
        >
          <span>全国から探す</span>
        </div>
      </div>
    );
  } else if (type === TYPE_PC) {
    return (
      <div className="area_selector">
        {areas.map((area, areaIndex) => (
          <div className="areas" key={areaIndex}>
            <span>{area.title}</span>
            {area.children.map((pref, prefIndex) => (
              <Link to={getPrefUrl(pref)} key={prefIndex}>
                {masterData.pref.bySlug[pref].shortName}
              </Link>
            ))}
          </div>
        ))}
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./common/area_selector.jsx